const sidebarReducer = (state, action) => {
  if (action.type === "TOGGLE_SIDEBAR") {
    return { ...state, isSidebarOpen: !state.isSidebarOpen };
  }
  if (action.type === "SET_SIDEBAR") {
    return { ...state, isSidebarOpen: action.payload };
  }
  throw new Error(`No matching "${action.type}" action type`);
};

export default sidebarReducer;
